import { PlantingEvents, StoreCrops } from '../../types';
import { adaptUapiPlantingResponse } from './uapiPlantingAdapter';
import { LegacyCropsMap } from '../types/LegacyCropsMap';
import { getGraphqlClient } from '../uapiConnection';
import { getSdk, UapiPlantingEventByCropSeason } from '../../graphql/sdk';

export async function requestUapiPlantingEvents(fieldId: string, cropsMap: StoreCrops): Promise<PlantingEvents> {
  const sdk = getSdk(getGraphqlClient());
  const response = await sdk.getPlantingEventAggregatesArd({ fieldId });
  const crops: LegacyCropsMap = Object.entries(cropsMap).reduce((accum, [legacySeasonCode, crop]) => ({
      ...accum,
      [crop['dfp-uuid']]: legacySeasonCode,
    }), {});

  const data = response.data.field?.plantingEventAggregates?.eventsByCropSeason || [];

  return adaptUapiPlantingResponse(data as UapiPlantingEventByCropSeason[], crops);
}
